import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-414db9de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-05" }, "資格を追加", -1))

import type { PropType } from "vue";
import { RouteLocationRaw } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddQualificationItem',
  props: {
  to: {
    type: Object as PropType<RouteLocationRaw>,
    default: () => ({})
  }
},
  emits: ["click"],
  setup(__props, { emit: emits }) {





// 親コンポーネントで @click を利用するケースがあるため、イベントをハンドリングしている
// 他コンポーネントでも RouterLink において to ではなく @click を利用したい場合、同様に対応する必要がある
function onClick() {
  emits("click");
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: __props.to,
    class: "add-qualification-item",
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createVNode(FeatherIcon, {
        icon: "plus-circle",
        size: "16",
        class: "mr-2"
      }),
      _createTextVNode(),
      _hoisted_1
    ], undefined, true),
    _: 1
  }, 8, ["to"]))
}
}

})